<template>
  <div id="login-container">
    <router-view />
    <div id="logo">
      <router-link to="/index">
        <img src="../../assets/img/logo.png" alt="" />
      </router-link>
    </div>
    <div id="denglu">
      <img src="../../assets/img/chongzmima.png" alt="" />
    </div>
    <div id="login-box" v-if="box">
      <div class="progressBar">
        <ul class="written">
          <li class="se">填写手机</li>
          <li class="se">验证身份</li>
          <li>设置新密码</li>
          <li class="hou">完成</li>
        </ul>
        <div class="bian"></div>
        <div class="strip"></div>
        <ul class="chart">
          <li class="se"></li>
          <li class="se"></li>
          <li></li>
          <li class="hou"></li>
        </ul>
        <img class="bian" src="../../assets/img/wancheng2.png" alt="" />
        <img class="aircraft" src="../../assets/img/fly icon2.png" alt="" />
      </div>
      <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules">
        <el-form-item prop="username" label-width="100px">
          <b class="icon-user">企业名称：</b>
          <el-input
            v-model="loginForm.result"
            class="username-style"
            :disabled="true"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="password" label-width="100px">
          <b class="icon-pass">手机号：</b>
          <el-input
            v-model="loginForm.username"
            class="password-style"
            :disabled="true"
          >
          </el-input>
        </el-form-item>
        <el-form-item prop="verification" label-width="100px">
          <b class="icon-pass">手机验证码：</b>
          <el-input
            v-model="code.code"
            placeholder="请输入手机验证码"
            class="Grap-style"
          >
          </el-input>
          <el-button
            @click="send()"
            style=" width: 110px;height: 40px;margin-left: 10px;background-color: #fff;border: 1px solid #0086FD;"
            type="success"
            :disabled="(disabled = !show)"
            ref="butStyle"
          >
            <span v-show="show" style="color: #0086FD">申请发送</span>
            <span v-show="!show" class="count" style="color: #C5C6D1"
              >{{ count }} s</span
            >
          </el-button>
        </el-form-item>
        <el-form-item size="large" class="login-but">
          <el-button type="primary" @click="login()">下一步</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="return" @click="onReturn()">
      <span>返回登陆</span>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.getRouterData();
  },
  data() {
    return {
      // 表单校验规则定义
      loginFormRules: {
        // username: [
        //   { required: true, message: "手机号必填", trigger: "blur" },
        //   { max: 11, message: "长度在11位手机号", trigger: "blur" }
        // ],
        // password: [
        //   { required: true, message: "密码必填", trigger: "blur" },
        //   { min: 6, max: 20, message: "不小于六位", trigger: "blur" }
        // ]
      },
      // form表单数据对象
      loginForm: {
        result: "",
        username: "" // 用户名称
      },
      phone: { phone: "" },
      pictureCode: "",
      box: true,
      num: true,
      show: true, // 初始启用按钮
      count: "", // 初始化次数
      timer: null,
      code: { code: "", phone: "" }
    };
  },
  methods: {
    getRouterData() {
      this.loginForm.username = this.$route.query.username;
      this.loginForm.result = this.$route.query.result;
    },
    // 返回登录事件
    onReturn() {
      this.$router.push("/login");
    },
    async login() {
      this.code.phone = this.phone.phone;
      var { data: dt } = await this.$http.post("general/checkCode", this.code);
      // console.log(dt);
      if (dt.status !== 200) {
        return this.$message.error(dt.msg);
      }

      if (dt.data === 1) {
        return this.$message.error("验证码过期");
      } else if (dt.data === 2) {
        return this.$message.error("验证码错误");
      } else if (dt.data === 3) {
        this.$message({
          message: "验证码正确",
          type: "success"
        });
      }

      // if(this.code.code===) {

      // }
      // this.$router.push("/modify");
      this.$router.push({
        path: "/modify",
        query: {
          username: this.loginForm.username
        }
      });
    },
    //发送验证码倒计时
    async send() {
      this.show = true;
      this.$refs.butStyle.$el.style.border = "1px solid #C5C6D1";
      // console.log(this.$refs.butStyle.$el);
      const TIME_COUNT = 60; //更改倒计时时间
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer); // 清除定时器
            this.timer = null;
            this.$refs.butStyle.$el.style.border = "1px solid #0086FD";
          }
        }, 1000);
      }

      this.phone.phone = this.loginForm.username;
      var { data: dt } = await this.$http.post("general/sendCode", this.phone);
      if (dt.status !== 200) {
        return this.$message.error(dt.msg);
      }
      // console.log(dt);
    }
  }
};
</script>

<style lang="less" scoped>
#login-container {
  width: 100%;
  height: 100%;
  min-width: 1000px;
  position: fixed;
  top: 0;
  left: 0;
  background-image: url(../../assets/img/beijing10.png);
  // z-index: -10;
  overflow: auto;
  background-repeat: no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -o-background-size: cover;
  background-position: center 0;

  #logo {
    margin-top: 40px;
    margin-left: 40px;
    margin-bottom: 60px;
    overflow: hidden;
  }

  #denglu {
    width: 235px;
    height: 55px;
    display: block;
    margin: 0 auto;
  }

  #login-box {
    position: absolute;
    width: 520px;
    height: 570px;
    background-color: #fff;
    border-radius: 10px;
    margin: 0 auto;
    margin-top: 50px;
    // margin-left: 700px;
    position: relative;
    .el-input {
      width: 320px;
      height: 40px;
    }
    .username-style {
      margin-top: 115px;
      // margin-left: 100px;
    }
    .password-style {
      margin-top: 20px;
      // margin-left: 100px;
    }
    .icon-user {
      position: absolute;
      left: 0;
      top: 0;
      margin-top: 150px;
      // margin-left: 100px;
      font-size: 14px;
    }
    .icon-pass {
      position: absolute;
      left: 0;
      top: 0;
      margin-top: -10px;
      // margin-left: 100px;
      font-size: 14px;
    }
    .el-button {
      width: 320px;
      height: 50px;
    }
    .login-but {
      position: absolute;
      bottom: 0;
      right: 0;
      margin-bottom: 60px;
      margin-right: 100px;
    }
    .Grap-style {
      width: 200px;
      height: 40px;
      margin-top: 20px;
    }
    .yztupian {
      position: absolute;
      right: 100px;
      top: 20px;
      cursor: pointer;
    }
    .progressBar .written {
      width: 100%;
      margin: 0 auto;
      li {
        list-style-type: none;
        float: left;
        margin-right: 60px;
        text-align: center;
        color: #a9acbb;
        margin-top: 45px;
        overflow: hidden;
        font-weight: 550;
      }
      .se {
        color: #0086fd;
      }
      .hou {
        margin-right: 0px;
      }
      // li:last-child {
      //   margin-right: 0px;
      // }
    }
    .progressBar .chart {
      list-style-type: none;
      position: absolute;
      top: 65px;
      left: 10px;

      li {
        float: left;
        width: 45px;
        height: 45px;
        background: #eff0f4;

        border-radius: 50%;
        margin-right: 80px;
      }
      .se {
        box-shadow: 0px 0px 18px 2px rgba(0, 134, 253, 0.2);
        background: #0086fd;
      }

      .hou {
        margin-right: 0px;
      }
    }
    .strip {
      width: 335px;
      height: 15px;
      background-color: #eff0f4;
      position: absolute;
      top: 95px;
      left: 93px;
    }
    .bian {
      position: absolute;
      top: 95px;
      left: 80px;
    }
    .aircraft {
      position: absolute;
      top: 85px;
      left: 240px;
    }
  }
}
.return {
  width: 140px;
  height: 50px;
  border: 1px solid rgb(255, 255, 255);
  border-radius: 6px;
  line-height: 50px;
  position: absolute;
  top: 30px;
  right: 35px;
  cursor: pointer;
  span {
    display: block;
    width: 70px;
    margin: 0 auto;
    color: rgba(255, 255, 255, 1);
  }
}
</style>
